<template>
  <section id="culture" class="company-culture-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">企业文化</h2>
        <div class="title-underline"></div>
      </div>
      
      <div class="culture-content-grid">
        <div 
          class="culture-text-content"
          v-motion
          :initial="{ opacity: 0, x: -50 }"
          :visible="{ opacity: 1, x: 0 }"
          :transition="{ duration: 0.8 }"
        >
          <h3 class="content-title">我们的使命与价值观</h3>
          
          <div class="values-container">
            <div class="value-item">
              <h4 class="value-title">
                <i class="fa-solid fa-compass value-icon"></i>
                使命
              </h4>
              <p class="value-description">
                通过创新医疗技术和卓越服务，为患者提供最优质的医疗体验，
                推动医学进步，守护人类健康。
              </p>
            </div>
            
            <div class="value-item">
              <h4 class="value-title">
                <i class="fa-solid fa-eye value-icon"></i>
                愿景
              </h4>
              <p class="value-description">
                成为国际领先的医疗服务提供者和医学创新中心，
                为全球患者带来健康与希望。
              </p>
            </div>
            
            <div class="value-item">
              <h4 class="value-title">
                <i class="fa-solid fa-heart value-icon"></i>
                核心价值观
              </h4>
              <ul class="values-list">
                <li class="value-list-item">
                  <i class="fa-solid fa-check-circle list-icon"></i>
                  <span><strong>患者至上：</strong>始终将患者需求放在首位，提供以患者为中心的医疗服务。</span>
                </li>
                <li class="value-list-item">
                  <i class="fa-solid fa-check-circle list-icon"></i>
                  <span><strong>追求卓越：</strong>不断提升医疗质量和技术水平，精益求精。</span>
                </li>
                <li class="value-list-item">
                  <i class="fa-solid fa-check-circle list-icon"></i>
                  <span><strong>诚信正直：</strong>坚持医疗伦理，保持透明、诚实的服务态度。</span>
                </li>
                <li class="value-list-item">
                  <i class="fa-solid fa-check-circle list-icon"></i>
                  <span><strong>创新进取：</strong>勇于探索新技术、新方法，推动医学进步。</span>
                </li>
                <li class="value-list-item">
                  <i class="fa-solid fa-check-circle list-icon"></i>
                  <span><strong>团队协作：</strong>鼓励跨学科合作，发挥集体智慧，为患者提供最佳治疗方案。</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div 
          class="culture-image-content"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visible="{ opacity: 1, x: 0 }"
          :transition="{ duration: 0.8 }"
        >
          <div class="image-grid">
            <div class="image-column">
              <div class="image-container rotate-2">
                <img 
                  src="https://space.coze.cn/api/coze_space/gen_image?image_size=square&prompt=Medical%20team%20collaboration%2C%20doctors%20and%20nurses%20working%20together&sign=c98f9be1a1fc2ea3d3bbb6ecc7b887bf" 
                  alt="医疗团队协作" 
                  class="culture-image"
                />
              </div>
              <div class="image-container -rotate-2 mt-8">
                <img 
                  src="@/assets/ga.png" 
                  alt="医生关怀患者" 
                  class="culture-image"
                />
              </div>
            </div>
            
            <div class="image-column mt-8">
              <div class="image-container -rotate-2">
                <img 
                  src="@/assets/zr.png" 
                  alt="医学研究团队" 
                  class="culture-image"
                />
              </div>
              <div class="image-container rotate-2">
                <img 
                  src="@/assets/yj.png" 
                   alt="医疗培训" 
                  class="culture-image"
                />
              </div>
            </div>
          </div>
          
          <div class="quote-container">
            <p class="quote-text">"医疗不仅是科学，更是关怀与责任。"</p>
            <p class="quote-author">— 张院长</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// 无需额外的逻辑，所有功能都在模板中实现
</script>

<style scoped>
.company-culture-section {
  padding: 3rem 0; /* 移动设备减小上下内边距 */
  background-color: white;
  overflow: hidden;
}

@media (min-width: 768px) {
  .company-culture-section {
    padding: 5rem 0; /* 桌面设备恢复较大内边距 */
  }
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .container {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 2rem;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 2rem; /* 移动设备减小间距 */
}

@media (min-width: 768px) {
  .section-header {
    margin-bottom: 4rem; /* 桌面设备增大间距 */
  }
}

.section-title {
  font-size: 1.5rem; /* 移动设备字体稍小 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .section-title {
    font-size: 2.25rem; /* 桌面设备字体更大 */
  }
}

.title-underline {
  width: 5rem;
  height: 0.25rem;
  background-color: #2563eb;
  margin: 0 auto;
  border-radius: 9999px;
}

.culture-content-grid {
  display: grid;
  grid-template-columns: 1fr; /* 默认单列布局 */
  gap: 2rem; /* 移动设备减小间距 */
  align-items: center;
}

@media (min-width: 1024px) {
  .culture-content-grid {
    grid-template-columns: 1fr 1fr; /* 桌面设备双列布局 */
    gap: 3rem;
  }
}

.content-title {
  font-size: 1.375rem; /* 移动设备稍小字体 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1.5rem;
  padding: 0 0.5rem; /* 增加左右内边距 */
}

@media (min-width: 768px) {
  .content-title {
    font-size: 1.5rem; /* 桌面设备稍大字体 */
  }
}

.values-container {
  space-y: 2rem;
  padding: 0 0.5rem; /* 增加左右内边距 */
}

.value-item {
  margin-bottom: 1.5rem; /* 移动设备减小间距 */
}

@media (min-width: 768px) {
  .value-item {
    margin-bottom: 2rem; /* 桌面设备恢复间距 */
  }
}

.value-title {
  font-size: 1.125rem; /* 移动设备稍小字体 */
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

@media (min-width: 768px) {
  .value-title {
    font-size: 1.25rem; /* 桌面设备稍大字体 */
  }
}

.value-icon {
  margin-right: 0.75rem;
}

.value-description {
  color: #374151;
  font-size: 1rem; /* 移动设备稍小字体 */
  line-height: 1.6; /* 优化行高提高可读性 */
}

@media (min-width: 768px) {
  .value-description {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

.values-list {
  space-y: 0.75rem;
  padding-left: 0.5rem; /* 调整列表左内边距 */
}

.value-list-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem; /* 增加列表项间距 */
}

.list-icon {
  color: #2563eb;
  margin-top: 0.25rem;
  margin-right: 0.75rem;
  flex-shrink: 0; /* 防止图标被压缩 */
}

.culture-image-content {
  position: relative;
  padding: 0 0.5rem; /* 增加左右内边距 */
}

.image-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%; /* 确保占满宽度 */
}

/* 小屏幕手机优化图片网格 */
@media (max-width: 375px) {
  .image-grid {
    gap: 0.75rem;
  }
}

.image-column {
  space-y: 1rem;
}

.image-container {
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 100%; /* 确保图片容器宽度100% */
}

.image-container:hover {
  transform: rotate(0);
}

.rotate-2 {
  transform: rotate(2deg);
}

.-rotate-2 {
  transform: rotate(-2deg);
}

.culture-image {
  width: 100%;
  height: auto;
  display: block; /* 移除图片底部间隙 */
}

.quote-container {
  position: relative; /* 默认相对定位 */
  bottom: 0;
  left: 0;
  background-color: #2563eb;
  color: white;
  padding: 1.25rem; /* 移动设备减小内边距 */
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  max-width: 100%; /* 移动设备占满宽度 */
  margin-top: 2rem; /* 增加顶部间距 */
}

/* 桌面设备调整引用框位置 */
@media (min-width: 1024px) {
  .quote-container {
    position: absolute;
    bottom: -1.5rem;
    left: -1.5rem;
    max-width: 15rem;
    padding: 1.5rem;
    margin-top: 0;
  }
}

.quote-text {
  font-style: italic;
  font-size: 1rem; /* 移动设备稍小字体 */
  line-height: 1.5rem;
}

@media (min-width: 768px) {
  .quote-text {
    font-size: 1.125rem;
  }
}

.quote-author {
  text-align: right;
  margin-top: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem; /* 移动设备稍小字体 */
}

@media (min-width: 768px) {
  .quote-author {
    font-size: 1rem;
  }
}
</style>
    